export const BUILD_VERSION = '1781620450';
